import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSustainabilityPerformance = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 18,
	viewBox: "0 0 20 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10 4V0H0V18H20V4H10ZM4 16H2V14H4V16ZM4 12H2V10H4V12ZM4 8H2V6H4V8ZM4 4H2V2H4V4ZM8 16H6V14H8V16ZM8 12H6V10H8V12ZM8 8H6V6H8V8ZM8 4H6V2H8V4ZM18 16H10V14H12V12H10V10H12V8H10V6H18V16ZM16 8H14V10H16V8ZM16 12H14V14H16V12Z",
		fill: "currentColor"
	})
});
export default SvgSustainabilityPerformance;
